//src/app/features/documents/Public.tsx
import { ScrollContainer } from 'app/layout/dashboardLayout/BoxLayout';
import { useGetGuestDirectoryItemsQuery } from 'app/services/constants';
import { DownloadIcon, FileIcon } from 'assets/icons';
import Spinner from 'Components/Spinner';
import { saveAs } from 'file-saver';
import { useParams } from 'react-router-dom';
import Documents from '.';

export interface IDocumentsProps {}

export default function Public({}: IDocumentsProps) {
  const { resourceType, resourceId } = useParams();

  const { data: document } = useGetGuestDirectoryItemsQuery(
    { filters: { id: +resourceId! } },
    { skip: !resourceId || resourceType === 'folder' },
  );

  if (resourceType === 'folder') {
    return (
      <ScrollContainer className="p-4">
        <Documents lockParentId={+resourceId!} />
      </ScrollContainer>
    );
  }

  if (resourceType === 'document' && document && document.file_object) {
    const saveFile = () => {
      if (!document.file_object?.file_url) return;
      saveAs(
        process.env.REACT_APP_URL + document.file_object.file_url,
        document.file_object?.title,
      );
    };

    return (
      <ScrollContainer className="p-4">
        {!document && <Spinner />}
        {document && !!document.file_object && (
          <div className="flex w-full   justify-center  ">
            <div className="max-w-xl flex p-4 w-96 shadow border-gray-100 border rounded-lg ">
              <span className="flex w-full gap-2 items-center">
                <FileIcon className="w-5 h-5 mr-3 shrink-0" />

                <span className="line-clamp-1 break-all text-ellipsis text-gray-dark font-semibold ">
                  {document.file_object.title}
                </span>
              </span>

              <DownloadIcon
                className="ml-auto mr-2 cursor-pointer w-5 h-5"
                onClick={saveFile}
              />
            </div>
          </div>
        )}
      </ScrollContainer>
    );
  }
  return <Spinner />;
}
